export const RADIO_GROUP_ORIENTATION = ['horizontal', 'vertical'] as const;
export type TRadioGroupOrientation = (typeof RADIO_GROUP_ORIENTATION)[number];
